import Dexie from 'dexie';
import store from 'store/store';

const db = new Dexie('POSOfflineDB');

db.version(1).stores({
  categories:    'id, name, display_order',
  products:      '++localId, id, category_name, name',
  cart:          '++localId, product_var',
  offlineOrders: '++id, status, synced, created_at',
  syncQueue:     '++id, order_id, created_at',
  settings:      'key',
});

// v2 — tag orders/queue entries with the account that created them, so a
// device shared between merchants (or a logout/session-expiry that happens
// before a sync completes) can't leak one account's pending sales into
// another's view, or destroy them. Rows written before this migration have
// no account_id; they're treated as visible-to-anyone (see getCurrentAccountId
// callers) rather than guessed at migration time, since the logged-in user
// in Redux isn't reliably populated yet at DB-open time.
db.version(2).stores({
  categories:    'id, name, display_order',
  products:      '++localId, id, category_name, name',
  cart:          '++localId, product_var',
  offlineOrders: '++id, status, synced, created_at, account_id',
  syncQueue:     '++id, order_id, created_at, account_id',
  settings:      'key',
});

// Stable identifier for the currently logged-in merchant account — used to
// scope offlineOrders/syncQueue so they survive logout/session-expiry without
// leaking across accounts on a shared device. Deliberately NOT the access
// token (which rotates/expires) — that would make a merchant's own re-login
// look like a different account and orphan their own queued orders.
export const getCurrentAccountId = () => {
  const user = store.getState()?.userDetails?.user;
  if (!user) return null;
  return user.id != null ? String(user.id) : (user.email || null);
};

// Rows written before the v2 migration (no account_id) are intentionally
// left visible regardless of who's logged in, rather than wiped or guessed.
export const belongsToCurrentAccount = (row) => {
  if (!row || row.account_id == null) return true;
  return row.account_id === getCurrentAccountId();
};

export default db;
